export default __webpack_public_path__ + "static/media/AG01.1.4b0135ad.mp3";